export default `
    <div id="#= data.id || "" #" class="pop-up-workspace-wrapper container #: data.classes || "" # #=data.bsc||""#" style="#=data.style || ""#">
        #= data.components #
    </div>
`;
